module.exports = __webpack_public_path__ + "img/4-2.92d00109.png";